import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// STICKY: each line stays until the next begins. Lines are ~5-6s apart; the last
// line of every scene gets ~6s of tail before the scene ends (see constants.ts).
//
// Every claim is grounded in EAKC-MVP (verified against the real code):
//   src/lib/rag/adaptive-chunker.ts          (CHUNKER_VERSION=6; per-contentType switch)
//   src/lib/code-intelligence/tree-sitter-parser.ts  (AST boundaries; 13-grammar dispatch)
//   src/lib/jobs/sync-worker.ts              (live ingest path; content_type detection)

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, holdSec: 6, caption: "Most RAG pipelines cut text every 2048 characters. That number has nothing to do with where meaning lives." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "Slice a function in half and you embed two fragments — neither one is the function." },
  { scene: "problem", fromSec: 6, holdSec: 6, caption: "Cut a markdown section mid-paragraph and the heading lands in a different chunk than its own text." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "The fix isn't a smaller number. It's cutting at the seams the content already has." },
  { scene: "intuition", fromSec: 6, holdSec: 6, caption: "Code has functions and classes. Markdown has headings. Tables have rows. Chunk on those." },
];

export const APPROACH: ScriptLine[] = [
  { scene: "approach", fromSec: 0.4, holdSec: 5.5, caption: "EAKC reads the content type first, then picks a strategy — adaptiveChunkStructured()." },
  { scene: "approach", fromSec: 6, holdSec: 6.5, caption: "Code, markdown, table, general: four lanes, one dispatch. Fixed-size is only the fallback." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 5.5, caption: "It's a literal switch on contentType — no model decides this, it's deterministic routing." },
  { scene: "code", fromSec: 6, holdSec: 6, caption: "Code goes to a tree-sitter pass: real AST node boundaries, not a regex guess." },
  { scene: "code", fromSec: 12, holdSec: 5.5, caption: "If tree-sitter can't parse the file, it falls back to a regex chunker — never to blind slicing." },
];

export const LANGS: ScriptLine[] = [
  { scene: "langs", fromSec: 0.4, holdSec: 5.5, caption: "The AST parser dispatches 13 grammars — the file's own header comment still says 10." },
  { scene: "langs", fromSec: 6, holdSec: 6, caption: "A doc comment right above a function gets attached to that function's chunk, not orphaned." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "Every strategy aims for the same ~512-token target, then merges tiny pieces and splits huge ones." },
  { scene: "payoff", fromSec: 6, holdSec: 6, caption: "The output is structural: each chunk carries its type, its title, and its file location." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5.5, caption: "Retrieval can only rank what ingestion preserved. Chunk on structure, not on a byte count." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: a RAG that can answer 'who calls this function?'" },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
